class AppCheckout {
    constructor() {
      this.serverUrl = 'https://checkout.np-shop-widget.site/create-checkout-link';
      this.init();
    }

    init() {
      this.persistTrackingParams();
      
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.attachListeners());
      } else {
        this.attachListeners();
      }
    }

    async persistTrackingParams() {
      try {
        const urlParams = new URLSearchParams(window.location.search);
        const gclid = urlParams.get('gclid');
        const fbclid = urlParams.get('fbclid');
        const fbc = this.getCookie('_fbc') || fbclid;
        const fbp = this.getCookie('_fbp');
        const ttclid = urlParams.get('ttclid');
        const ttp = this.getCookie('_ttp');

        // UTM: saving to localStorage
        const utmParams = {};
        ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'].forEach(param => {
          if (urlParams.has(param)) utmParams[param] = urlParams.get(param);
        });
        if (Object.keys(utmParams).length > 0) {
          try {
            localStorage.setItem('utm_params', JSON.stringify(utmParams));
          } catch (e) {}
        }

        // If new go to Shopify Cart Attributes
        if (gclid || fbc || fbp || ttclid || ttp) {
          console.log('App: Saving tracking params to Shopify Cart Attributes...');

          const attributes = {};
          if (gclid) attributes['_App_gclid'] = gclid;
          if (fbc) attributes['_App_fbc'] = fbc;
          if (fbp) attributes['_App_fbp'] = fbp;
          if (ttclid) attributes['_App_ttclid'] = ttclid;
          if (ttp) attributes['_App_ttp'] = ttp;

          await fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ attributes })
          });
          
          console.log('App: Tracking params saved to cart.');
        }
      } catch (e) {
        console.error('Error persisting tracking params:', e);
      }
    }

    /** UTM: from localStorage, from URL */
    getUTMParams() {
      try {
        const stored = localStorage.getItem('utm_params');
        if (stored) return JSON.parse(stored);
      } catch (e) {}
      const params = new URLSearchParams(window.location.search);
      const utmParams = {};
      ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'].forEach(param => {
        if (params.has(param)) utmParams[param] = params.get(param);
      });
      return utmParams;
    }

    /** Parsing GA session: ga_session_id + ga_session_number from _ga_* cookie */
    getGALastSession() {
      const cookies = document.cookie.split('; ');
      let lastSession = null;
      for (const cookie of cookies) {
        const eq = cookie.indexOf('=');
        if (eq === -1) continue;
        const name = cookie.slice(0, eq).trim();
        const value = cookie.slice(eq + 1).trim();
        if (name.startsWith('_ga_') && name !== '_ga') {
          const match = value.match(/s(\d+).*?\$o(\d+)/);
          if (match) {
            const session = { ga_session_id: match[1], ga_session_number: parseInt(match[2], 10) };
            if (!lastSession || session.ga_session_id > lastSession.ga_session_id) lastSession = session;
          }
        }
      }
      return lastSession;
    }

    getCookie(name) {
      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${name}=`);
      if (parts.length === 2) return parts.pop().split(';').shift();
      return null;
    }

    getQueryParam(name) {
      const urlParams = new URLSearchParams(window.location.search);
      return urlParams.get(name) || sessionStorage.getItem(`App_${name}`);
    }

    /**
     * Normalize properties of the product from the cart to an array of { name, value }.
     * Cart API can return an array or an object.
     */
    normalizeItemProperties(properties) {
      if (!properties || (Array.isArray(properties) && properties.length === 0)) {
        return [];
      }
      if (Array.isArray(properties)) {
        return properties
          .filter(p => p && (p.name != null || p.key != null))
          .map(p => ({ name: p.name ?? p.key, value: String(p.value ?? '') }));
      }
      if (typeof properties === 'object') {
        return Object.entries(properties)
          .filter(([, v]) => v != null && v !== '')
          .map(([name, value]) => ({ name, value: String(value) }));
      }
      return [];
    }

    attachListeners() {
      document.addEventListener('click', (e) => {
        const target = e.target;
        
        const className = (target.className || '') + '';
        const text = (target.textContent || target.value || '').toLowerCase();
        const aria = (target.getAttribute && target.getAttribute('aria-label') || '').toLowerCase();
        const isBuyNowByClass = /(^|\\s)(buy[-_ ]?now|product-form__buy-now|shopify-payment-button)(\\s|$)/i.test(className);
        const isBuyNowByAttr = target.hasAttribute && (target.hasAttribute('data-buy-now') || target.hasAttribute('data-buy_now') || target.hasAttribute('data-action') && /buy[-_ ]?now/i.test(target.getAttribute('data-action')));
        const isBuyNowByText = /buy it now|buy now|купить сейчас/i.test(text) || /buy it now|buy now|купить сейчас/i.test(aria);

        if (
          target.id === 'CartDrawer-Checkout' ||
          target.closest('#CartDrawer-Checkout') ||
          target.name === 'checkout' ||
          target.closest('[name="checkout"]') ||
          target.classList.contains('cart__checkout-button') ||
          target.closest('.cart__checkout-button') ||
          target.classList.contains('cart__checkout') ||
          target.closest('.cart__checkout') ||
          (target.tagName === 'A' && target.href && target.href.includes('/checkout')) ||
          target.closest('a[href*="/checkout"]') ||
          target.id === 'checkout' ||
          target.closest('#checkout') ||
          target.hasAttribute('data-checkout') ||
          target.closest('[data-checkout]') ||
          isBuyNowByClass ||
          isBuyNowByAttr ||
          isBuyNowByText ||
          target.closest('[data-buy-now], [data-buy_now], .product-form__buy-now, .shopify-payment-button, .buy-now, #buy-now')
        ) {
          this.handleCheckout(e);
        }
      }, true); // Используем capture phase для раннего перехвата

      // Обработка отправки форм чекаута
      document.addEventListener('submit', (e) => {
        const form = e.target;
        
        if (
          form.id === 'CartDrawer-Form' ||
          form.action && (form.action.includes('/checkout') || form.action === '/cart') ||
          form.querySelector('[name="checkout"]') ||
          form.querySelector('#CartDrawer-Checkout') ||
          form.querySelector('.cart__checkout-button')
        ) {
          this.handleCheckout(e);
        }
      }, true);

      // MutationObserver to track dynamically added elements
      this.observeDynamicElements();
    }

    observeDynamicElements() {
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === 1) { // Element node
              // Check if the added element is a checkout button
              if (
                node.id === 'CartDrawer-Checkout' ||
                node.classList?.contains('cart__checkout-button') ||
                node.classList?.contains('cart__checkout') ||
                node.name === 'checkout' ||
                (node.tagName === 'BUTTON' && node.type === 'submit' && node.name === 'checkout')
              ) {
                // The element will be processed through event delegation
                console.log('Checkout button found:', node);
              }
              
              // Check nested elements
              if (node.querySelector) {
                const checkoutButtons = node.querySelectorAll(
                  '#CartDrawer-Checkout, .cart__checkout-button, [name="checkout"], .cart__checkout'
                );
                if (checkoutButtons.length > 0) {
                  console.log('Dynamic checkout button found');
                }
              }
            }
          });
        });
      });

      // Observe changes in document.body
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }

    /**
     * When Buy Now is clicked on a product page with an empty cart,
     * add the item to cart first via /cart/add.js, then proceed with checkout.
     */
    async addFormItemsToCart(event) {
      const target = event.target;
      // For submit events the target IS the form; for click events find the closest form
      const form = (target.tagName === 'FORM')
        ? target
        : (target.closest ? target.closest('form') : null);

      if (!form) return false;

      // Only act on product forms (action "/cart/add" or form contains a variant id input)
      const isProductForm =
        (form.action && form.action.includes('/cart/add')) ||
        form.querySelector('input[name="id"], input[name="variant_id"]');

      if (!isProductForm) return false;

      try {
        console.log('App: cart is empty — adding item from product form first...');
        const formData = new FormData(form);
        // Remove the "checkout" field so Shopify doesn't redirect on its own
        formData.delete('checkout');

        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: formData
        });

        if (!response.ok) {
          const err = await response.text();
          console.error('App: failed to add item to cart:', err);
          return false;
        }

        const added = await response.json();
        console.log('App: item added to cart:', added);
        return true;
      } catch (e) {
        console.error('App: error adding item to cart:', e);
        return false;
      }
    }

    async handleCheckout(event) {
      console.log('=== CHECKOUT HANDLER STARTED ===');
      event.preventDefault();
      event.stopPropagation();

      try {
        console.log('Step 1: Getting cart data...');
        let cartData = await this.getCartData();
        console.log('Cart data received:', cartData);

        // If cart is empty and this looks like a Buy Now click from a product page,
        // add the item to cart first and then re-fetch cart data.
        if (!cartData.items || cartData.items.length === 0) {
          console.log('App: cart is empty, checking if Buy Now from product form...');
          const added = await this.addFormItemsToCart(event);
          if (added) {
            cartData = await this.getCartData();
            console.log('App: cart after adding item:', cartData);
          }
        }
        
        if (!cartData.items || cartData.items.length === 0) {
          console.warn('Cart is empty!');
          alert('Корзина пуста. Додайте товари перед оформленням замовлення.');
          return;
        }

        // Format data for checkout
        const productsData = this.formatCartData(cartData);
        const shopDomain = this.getShopDomain();

        // data from the cart attributes
        const cartAttributes = cartData.attributes || {};
        
        console.log('App: Cart Level Discounts:', cartData.cart_level_discount_applications);
        
        // Get analytics data (from cart attributes or cookies)
        const fbp = cartAttributes['_App_fbp'] || this.getCookie('_fbp');
        const fbc = cartAttributes['_App_fbc'] || this.getCookie('_fbc') || this.getQueryParam('fbclid');
        const gclid = cartAttributes['_App_gclid'] || this.getQueryParam('gclid');
        const ttclid = cartAttributes['_App_ttclid'] || this.getQueryParam('ttclid');
        const ttp = cartAttributes['_App_ttp'] || this.getCookie('_ttp');
        
        // Google Analytics Client ID 
        let gaClientId = this.getCookie('_ga');
        if (gaClientId) {
            const parts = gaClientId.split('.');
            if (parts.length >= 4) {
                gaClientId = parts[2] + '.' + parts[3];
            } else if (parts.length >= 2) {
                gaClientId = parts.slice(-2).join('.');
            }
        }

        // Google Analytics Session: full parsing (ga_session_id + ga_session_number)
        const gaSession = this.getGALastSession();
        const gaSessionId = gaSession ? gaSession.ga_session_id : null;
        const gaSessionNumber = gaSession ? gaSession.ga_session_number : null;

        // UTM from the site (localStorage or URL) for attribution in GA4
        const utmParams = this.getUTMParams();
        
        // Define locale of the shop
        const locale = window.Shopify?.locale || document.documentElement.lang || 'uk';
        console.log('Detected locale:', locale);
        
        // Define the currency of the shop
        const currencyCode =
          window.AppCheckoutConfig?.currencyCode ||
          window.AppCheckoutConfig?.currency ||
          window.Shopify?.currency?.active ||
          window.Shopify?.currency?.currency ||
          window.Shopify?.currency?.shop_currency ||
          null;
        console.log('Detected currency:', currencyCode);
        
        // Format data with products and shop domain (+ UTM and ga_session_number for GA4)
        const checkoutData = {
          products: productsData,
          shopDomain: shopDomain,
          cart_level_discount_applications: cartData.cart_level_discount_applications || [],
          discount_codes: cartData.discount_codes || [],
          fbp: fbp,
          fbc: fbc,
          gclid: gclid,
          ttclid: ttclid,
          ttp: ttp,
          ga_client_id: gaClientId,
          ga_session_id: gaSessionId,
          ga_session_number: gaSessionNumber,
          userAgent: navigator.userAgent,
          locale: locale,
          currencyCode: currencyCode,
          ...(utmParams.utm_source && { utm_source: utmParams.utm_source }),
          ...(utmParams.utm_medium && { utm_medium: utmParams.utm_medium }),
          ...(utmParams.utm_campaign && { utm_campaign: utmParams.utm_campaign }),
          ...(utmParams.utm_term && { utm_term: utmParams.utm_term }),
          ...(utmParams.utm_content && { utm_content: utmParams.utm_content })
        };
        
        // Push begin_checkout to dataLayer on the shop domain so GA receives it in the browser session
        try {
          window.dataLayer = window.dataLayer || [];
          const gaItems = productsData.map(item => ({
            item_id: item.variant_id || item.product_id || null,
            item_name: item.name || item.title || null,
            price: typeof item.price === 'number' ? item.price : parseFloat(item.price || 0),
            quantity: parseInt(item.quantity || 1, 10)
          }));
          const totalValue = gaItems.reduce((sum, it) => sum + (it.price || 0) * (it.quantity || 0), 0);
          window.dataLayer.push({
            event: 'begin_checkout',
            currency: currencyCode || 'UAH',
            value: totalValue,
            items: gaItems
          });
          console.log('App: pushed begin_checkout to dataLayer', { totalValue, gaItems });
        } catch (err) {
          console.warn('App: failed to push begin_checkout to dataLayer', err);
        }

        console.log('Step 3: Sending data to checkout server...');
        // Отправляем данные на checkout сервер и получаем ссылку
        let checkoutUrl = await this.sendToServer(checkoutData);
        console.log('Checkout URL received:', checkoutUrl);
        
        if (checkoutUrl) {
          // Подмешиваем UTM и gclid в URL чекаута, чтобы на app-checkout они подхватились из URL (другой домен — своего localStorage нет)
          const url = new URL(checkoutUrl);
          if (utmParams.utm_source) url.searchParams.set('utm_source', utmParams.utm_source);
          if (utmParams.utm_medium) url.searchParams.set('utm_medium', utmParams.utm_medium);
          if (utmParams.utm_campaign) url.searchParams.set('utm_campaign', utmParams.utm_campaign);
          if (utmParams.utm_term) url.searchParams.set('utm_term', utmParams.utm_term);
          if (utmParams.utm_content) url.searchParams.set('utm_content', utmParams.utm_content);
          if (gclid) url.searchParams.set('gclid', gclid);
          if (ttclid) url.searchParams.set('ttclid', ttclid);
          checkoutUrl = url.toString();
          console.log('✅ Checkout URL received, redirecting user...');
          window.location.href = checkoutUrl;
        } else {
          console.error('❌ Failed to get checkout URL');
          alert('Failed to create checkout URL. Please try again.');
        }
      } catch (error) {
        console.error('❌ ERROR in checkout handler:', error);
        console.error('Error stack:', error.stack);
        console.error('Error message:', error.message);

        if (error.code === 'trial_expired') {
          alert(error.message || 'Пробний період магазину закінчився. Оформлення замовлення тимчасово недоступне. Зверніться до власника магазину.');
        }
      }
      console.log('=== CHECKOUT HANDLER FINISHED ===');
    }

    async getCartData() {
      try {
        console.log('Fetching cart data from /cart.js...');
        // Use Shopify Cart API to get cart data
        const response = await fetch('/cart.js');
        console.log('Cart API response status:', response.status, response.statusText);
        
        if (!response.ok) {
          const errorText = await response.text();
          console.error('Cart API error response:', errorText);
          throw new Error(`Failed to get cart data: ${response.status} ${response.statusText}`);
        }
        
        const cart = await response.json();
        console.log('Cart data parsed:', cart);
        console.log('Cart items:', cart.items);
        return cart;
      } catch (error) {
        console.error('Error getting cart data:', error);
        console.error('Error details:', {
          message: error.message,
          stack: error.stack,
          name: error.name
        });
        throw error;
      }
    }

    formatCartData(cart) {
      // Формируем массив данных в требуемом формате
      const dataArray = cart.items.map(item => {
        // Цена в Shopify хранится в центах, делим на 100 для получения цены
        // Используем final_price или discounted_price, если они доступны (со скидками)
        const price = item.final_price / 100;
        const originalPrice = item.original_price / 100;
        
        // Получаем название варианта (размер, цвет и т.д.)
        const variant = item.variant_title || item.title.split(' / ').slice(1).join(' / ') || '';
        
        // Название товара (без варианта)
        const name = item.product_title || item.title.split(' / ')[0] || item.title;
        
        // Получаем ID продукта и варианта максимально надежно
        const productId = item.product_id || item.product?.id || null;
        const variantId = item.variant_id || item.id || null;
        
        // Собираем примененные скидки из всех возможных полей Shopify API
        const discountsApplications = item.line_level_discount_applications || [];
        const discountsAllocations = item.line_level_discount_allocations || [];
        const simpleDiscounts = item.discounts || [];
        
        // Массив для сбора названий
        let discountTitles = [];
        
        // 1. Из приложений
        discountsApplications.forEach(d => {
          if (d.title) discountTitles.push(d.title);
          if (d.key) discountTitles.push(d.key);
        });
        
        // 2. Из аллокаций (самое частое место)
        discountsAllocations.forEach(d => {
          if (d.discount_application) {
            if (d.discount_application.title) discountTitles.push(d.discount_application.title);
            if (d.discount_application.key) discountTitles.push(d.discount_application.key);
          }
        });
        
        // 3. Из простого массива discounts
        simpleDiscounts.forEach(d => {
          if (d.title) discountTitles.push(d.title);
        });
        
        // Оставляем только уникальные названия и убираем пустые
        const uniqueDiscountTitles = [...new Set(discountTitles)].filter(Boolean);
        
        console.log(`App: Item ${name}`, { productId, variantId, discountTitles: uniqueDiscountTitles });
        console.log('App: FULL ITEM DATA:', item);
        
        // Получаем изображение продукта
        // В Shopify Cart.js API изображение может быть в разных форматах
        const image = item.image || item.featured_image || item.product_image || null;
        
        // Атрибуты товара (properties) — гравировка, надписи и т.д. Передаём в заказ
        const properties = this.normalizeItemProperties(item.properties);
        
        return {
          name: name,
          price: price,
          original_price: originalPrice,
          quantity: item.quantity,
          variant: variant,
          variant_id: variantId,
          product_id: productId,
          discount_titles: uniqueDiscountTitles,
          discounts: discountsAllocations.map(d => ({
            amount: d.amount / 100,
            title: d.discount_application?.title || d.discount_application?.key || 'Discount'
          })),
          image: image,
          properties: properties
        };
      });

      return dataArray;
    }

    formatDraftOrderData(cart) {
      console.log('Formatting draft order data from cart:', cart);
      
      if (!cart || !cart.items || cart.items.length === 0) {
        console.warn('Cart is empty or has no items!');
        return {
          lineItems: [],
          note: "Order created via App Checkout",
          tags: ["App-checkout"],
        };
      }
      
      // Формируем данные для создания draft order
      const lineItems = cart.items.map((item, index) => {
        console.log(`Processing item ${index + 1}:`, item);
        
        // Цена в Shopify хранится в центах, делим на 100 для получения цены
        // Используем final_price или discounted_price, если они доступны (со скидками)
        const itemPrice = item.final_price;
        const price = (itemPrice / 100).toFixed(2);
        console.log(`  Price: ${itemPrice} cents = ${price}`);
        
        // Название товара с вариантом
        const title = item.product_title || item.title.split(' / ')[0] || item.title;
        const variantTitle = item.variant_title;
        const fullTitle = variantTitle ? `${title} - ${variantTitle}` : title;
        console.log(`  Title: ${fullTitle}`);
        console.log(`  Variant title: ${variantTitle || 'none'}`);
        
        // Формируем variant ID в формате GID
        const variantId = item.variant_id 
          ? `gid://shopify/ProductVariant/${item.variant_id}`
          : null;
        console.log(`  Variant ID: ${variantId || 'none'}`);
        console.log(`  Quantity: ${item.quantity}`);
        
        const lineItem = {
          title: fullTitle,
          quantity: item.quantity,
          originalUnitPrice: price,
        };
        
        // Добавляем variant ID если есть
        if (variantId) {
          lineItem.variantId = variantId;
        }
        
        // Атрибуты товара (properties) для draft order — GraphQL customAttributes: { key, value }
        const properties = this.normalizeItemProperties(item.properties);
        if (properties.length > 0) {
          lineItem.customAttributes = properties.map(p => ({ key: p.name, value: p.value }));
        }
        
        console.log(`  Final line item:`, lineItem);
        return lineItem;
      });

      const result = {
        lineItems,
        note: "Order created via App Checkout",
        tags: ["App-checkout"],
      };
      
      console.log('Formatted draft order data:', JSON.stringify(result, null, 2));
      return result;
    }

    async createDraftOrder(data) {
      try {
        // Get shop domain for app proxy
        const shopDomain = this.getShopDomain();
        console.log('Shop domain:', shopDomain);
        
        // Add shop to query params for app proxy
        const url = `/apps/draft-order?shop=${encodeURIComponent(shopDomain)}`;
        
        // Add shopDomain to request body as well
        const requestData = {
          ...data,
          shopDomain: shopDomain
        };
        
        console.log('Sending request to:', url);
        console.log('Request data:', JSON.stringify(requestData, null, 2));
        
        const response = await fetch(url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(requestData)
        });

        console.log('Response status:', response.status, response.statusText);
        console.log('Response headers:', Object.fromEntries(response.headers.entries()));

        if (!response.ok) {
          const errorText = await response.text();
          console.error('Server error response:', errorText);
          throw new Error(`Server error: ${response.status} ${response.statusText}. Response: ${errorText}`);
        }

        const result = await response.json();
        console.log('Response JSON parsed:', JSON.stringify(result, null, 2));
        return result;
      } catch (error) {
        console.error('Error creating draft order:', error);
        console.error('Error details:', {
          message: error.message,
          stack: error.stack,
          name: error.name
        });
        throw error;
      }
    }

    getShopDomain() {
      // Получаем Shopify домен магазина (shop-name.myshopify.com)
      
      // 1. Пытаемся получить из window.Shopify (стандартный способ в Shopify темах)
      if (window.Shopify && window.Shopify.shop) {
        const shopName = window.Shopify.shop;
        // Если уже содержит .myshopify.com, возвращаем как есть
        if (shopName.includes('.myshopify.com')) {
          return shopName;
        }
        // Иначе добавляем .myshopify.com
        return `${shopName}.myshopify.com`;
      }
      
      // 2. Пытаемся получить из мета-тега
      const shopMeta = document.querySelector('meta[name="shop"]');
      if (shopMeta && shopMeta.content) {
        const shopName = shopMeta.content;
        if (shopName.includes('.myshopify.com')) {
          return shopName;
        }
        return `${shopName}.myshopify.com`;
      }
      
      // 3. Пытаемся получить из URL (для myshopify.com доменов)
      const hostname = window.location.hostname;
      if (hostname.includes('.myshopify.com')) {
        return hostname;
      }
      
      // 4. Пытаемся получить из data-атрибутов
      const shopData = document.querySelector('[data-shop]');
      if (shopData) {
        const shopName = shopData.getAttribute('data-shop');
        if (shopName && shopName.includes('.myshopify.com')) {
          return shopName;
        }
        if (shopName) {
          return `${shopName}.myshopify.com`;
        }
      }
      
      // Fallback: если ничего не найдено, возвращаем hostname
      // (для кастомных доменов это может быть не Shopify домен)
      console.warn('Shop domain not found, using hostname as fallback:', hostname);
      return hostname;
    }

    async sendToServer(data) {
      if (!this.serverUrl) {
        console.warn('URL сервера не указан');
        return null;
      }

      try {
        const response = await fetch(this.serverUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(data)
        });

        const result = await response.json().catch(() => ({}));

        if (!response.ok) {
          const err = new Error(result.message || `Ошибка сервера: ${response.status}`);
          err.code = result.error || null;
          throw err;
        }

        // Проверяем успешность ответа
        if (result.success && result.url) {
          console.log('Checkout URL получен:', result.url);
          if (result.orderId) {
            console.log('Order ID:', result.orderId);
          }
          return result.url;
        }
        
        // Fallback на другие возможные поля
        return result.url || result.checkout_url || result.link || null;
      } catch (error) {
        console.error('Ошибка отправки данных на сервер:', error);
        throw error;
      }
    }
  }
  
  const appCheckout = new AppCheckout();
